// extracted by mini-css-extract-plugin
export default {"addToCartControl":"VT-z","giftCard":"WT-z","btnContainer":"XT-z","cartButton":"YT-z","disabled":"ZT-z","stockMessage":"_T-z"};